export default __webpack_public_path__ + "static/media/LegacyLogoWhite.487814f2.png";